var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"token-amount",class:{
        negative: _vm.negative,
    }},[_vm._v(_vm._s(_vm.amount)+" "),(_vm.useSymbol)?_c('span',{staticClass:"token-symbol"},[_vm._v(_vm._s(_vm.useSymbol))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }